module.exports = "/_next/static/images/associationLogo11-4ca06d272d5d61929013dc4a09bcb309.webp";